// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__1GsPM","content":"styles_content__1jtzo"};